export const PACKAGE_NAME = 'jiraIssueTableInlineIssueCreate';
export const TEAM_NAME = 'empanada';

export const JSC_ONBOARDING_INLINE_CREATE_MESSAGE_ID = 'jsc_onboarding_inline_create';
export const STARGATE_URL = '/gateway/api';
